import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import {
  AppAuthGate,
  AppShell,
  HomePage as MemberHomePage,
  ChatPage as MemberChatPage,
  CheckInsPage,
  RecordsPage,
  RecordDetailPage,
  BookmarksPage,
  AnalysisPage,
  FindCarePage,
  CrisisPage,
  SettingsPage as MemberSettingsPage,
  VoicePage,
  AccountPage,
  CommunityFeed,
  GroupDetail,
  DirectMessages,
  CommunityEvents,
  TrialsPage,
  SavedTrialsPage,
  GenomicsPage,
  AdminDashboardPage,
} from './index';
import LifetimeDrawAdminPage from './pages/LifetimeDrawAdminPage';

/**
 * Member app route tree under /app (must be invoked as {memberAppRoute()} inside <Routes>).
 */
export function memberAppRoute() {
  return (
    <Route
      key="member-app"
      path="/app"
      element={
        <AppAuthGate>
          <AppShell />
        </AppAuthGate>
      }
    >
      <Route index element={<MemberHomePage />} />
      <Route path="chat" element={<Navigate to="/app" replace />} />
      <Route path="c/:id" element={<MemberChatPage />} />
      <Route path="check-ins" element={<CheckInsPage />} />
      <Route path="records" element={<RecordsPage />} />
      <Route path="records/:id" element={<RecordDetailPage />} />
      <Route path="bookmarks" element={<Navigate to="/app/records?tab=bookmarks" replace />} />
      <Route path="analysis" element={<AnalysisPage />} />
      <Route path="care" element={<FindCarePage />} />
      <Route path="crisis" element={<Navigate to="/app" replace />} />
      <Route path="settings" element={<MemberSettingsPage />} />
      <Route path="voice" element={<VoicePage />} />
      <Route path="account" element={<AccountPage />} />
      <Route path="community" element={<CommunityFeed />} />
      <Route path="community/g/:id" element={<GroupDetail />} />
      <Route path="community/chat" element={<DirectMessages />} />
      <Route path="community/events" element={<CommunityEvents />} />
      <Route path="trials" element={<TrialsPage />} />
      <Route path="trials/saved" element={<Navigate to="/app/trials?tab=saved" replace />} />
      <Route path="genomics" element={<GenomicsPage />} />
      <Route path="admin" element={<AdminDashboardPage />} />
      <Route path="admin/lifetime-draw" element={<LifetimeDrawAdminPage />} />
      <Route path="*" element={<Navigate to="/app" replace />} />
    </Route>
  );
}
